
import {Icon, IconNode} from "lucide-react";
import React from "react";


const InfoCircleIconNode: IconNode = [
    [
        "path",
        {
            d: "M12 1C5.92529 1 1 5.92707 1 12C1 18.0765 5.92529 23 12 23C18.0747 23 23 18.0765 23 12C23 5.92707 18.0747 1 12 1ZM12 5.87903C13.0289 5.87903 13.8629 6.71308 13.8629 7.74194C13.8629 8.77079 13.0289 9.60484 12 9.60484C10.9711 9.60484 10.1371 8.77079 10.1371 7.74194C10.1371 6.71308 10.9711 5.87903 12 5.87903ZM14.4839 17.1452C14.4839 17.4391 14.2456 17.6774 13.9516 17.6774H10.0484C9.75445 17.6774 9.51613 17.4391 9.51613 17.1452V16.0806C9.51613 15.7867 9.75445 15.5484 10.0484 15.5484H10.5806V12.7097H10.0484C9.75445 12.7097 9.51613 12.4714 9.51613 12.1774V11.1129C9.51613 10.819 9.75445 10.5806 10.0484 10.5806H12.8871C13.181 10.5806 13.4194 10.819 13.4194 11.1129V15.5484H13.9516C14.2456 15.5484 14.4839 15.7867 14.4839 16.0806V17.1452Z",
            key: "infoCirclePath0"
        }
    ]
];

interface InfoCircleProps {
    size?: string | number;
    className?: string;
    fill?: string
    color?: string;
}

export default function InfoCircle({ size, className, fill="#818181", color="none" }: InfoCircleProps) {
    return (
        <Icon iconNode={InfoCircleIconNode} size={size} className={className} fill={fill} color={color} />
    );
}
